import React, { useState, useEffect } from "react";

import Header from "../components/header";
import markersection from "../assets/birthdaycards/1.png";
import { PersistGate } from "redux-persist/integration/react";

import img1 from "../assets/birthdaycards/1.png";
import img2 from "../assets/birthdaycards/2.png";
import img3 from "../assets/promotionmaker/3.webp";

import img42 from "../assets/birthdaycards/42.webp";
import img43 from "../assets/birthdaycards/43.webp";
import img44 from "../assets/birthdaycards/44.webp";


import { LazyLoadImage } from "react-lazy-load-image-component";
import { useNavigate } from "react-router-dom";
import img4 from "../assets/promotionmaker/2.png";
import img5 from "../assets/promotionmaker/3.png";
import img6 from "../assets/promotionmaker/3.png";

import img7 from "../assets/promotionmaker/6.webp";
import img8 from "../assets/promotionmaker/7.webp";
import img9 from "../assets/promotionmaker/8.webp";

import Button from "@mui/material/Button";
import axios from "axios";
import Footer from "../components/Footer";
import { useSelector, useDispatch } from "react-redux";
import { loginModal } from "../Redux/authAction";
import { NavLink } from "react-router-dom";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import apiConfig from '../config/api.js';

const Catelog = () => {
  const isLang = useSelector((state) => state.authReducer.lang);

  const [data, setData] = useState([]);
  const [img, setImg] = useState(`${img1}`);

  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  const dispatch = useDispatch();

  const handleOpen = () => {
    dispatch(loginModal(true));
    setOpenModel(false);
  };
  const handelOpenModel = () => {
    dispatch(loginModal(false));
    setOpenModel(true);
  };
  const handleClose = () => {
    dispatch(loginModal(false));
    dispatch(loginModal(false));
  };
  const handleCloseModel = () => setOpenModel(false);
  const [openModel, setOpenModel] = useState(false);

  // Function
  const [menu, setMenu] = useState("");
  const handleMouseOver = (type) => {
    setMenu(type);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiConfig.API_URL}/aapi/tempbycat.php?title=Birthday Cards`
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  console.log("data-=-=-=-", data);
  return (
    <>
      <Header menu={menu} setMenu={setMenu} />
      <div onMouseOver={() => handleMouseOver("")} className="text-black"></div>
      <div className="pt-20 bg-purple-500">
      <div className="grid grid-cols-2 p-5">
  <div className={`p-10 ml-5 text-white text-[16px] font-[100px] ${isLang === "eng" ? "text-left" : "text-right"}`}>
    <p className="text-4xl font-semibold">
      {isLang === "eng" 
        ? "Make Lasting Memories with Our Birthday Invitations" 
        : "اصنع ذكريات لا تُنسى مع دعوات أعياد الميلاد الخاصة بنا"}
    </p>
    <br />
    <p style={{fontSize:"16px"}}>
      {isLang === "eng" 
        ? "Every birthday itself becomes a celebration of life, a newcomer of another piece in your unique story. Making your birthday invites just like you is simply the best way to share your celebration joyfully and with your style."
        : "كل عيد ميلاد بحد ذاته احتفالاً بالحياة، ووافداً جديداً لقطعة أخرى في قصتك الفريدة. إن تصميم دعوات عيد ميلادك لتصبح مشابهة لك هي ببساطة أفضل طريقة لمشاركة احتفالك بفرح وبأسلوبك الخاص."}
    </p>
    <br />
    <p style={{fontSize:"16px"}}>
      {isLang === "eng"
        ? "With Maker4U birthday card templates, you can freely express to your friends and family members how fun their upcoming birthdays are going to be. Design the Birthday Invitations to suit your mood, adding only your creativity to make them look uniquely yours. You can save time and effort when you use our user-friendly tools that are tailored to facilitate the planning process, and you will enjoy it more."
        : "باستخدام نماذج بطاقات عيد الميلاد من Maker4U، يمكنك التعبير بحرية لأصدقائك وأفراد عائلتك عن مدى متعة أعياد ميلادهم القادمة. صمم دعوات عيد الميلاد لتناسب طبعك، وأضف إبداعك لجعلها تبدو فريدة من نوعها. يمكنك توفير الوقت والجهد عند استخدام أدواتنا سهلة الاستخدام والمصممة لتسهيل عملية التخطيط، وستستمتع بها أكثر."}
    </p>
    <br />
  </div>

  <div>
    <LazyLoadImage src={`${markersection}`} />
  </div>
</div>

      </div>
      <p className="text-[32px] text-center font-[500] mt-10">
  {isLang === "eng"
    ? "Choose from a variety of free birthday invitation templates"
    : "اختر من بين مجموعة متنوعة من نماذج دعوة عيد الميلاد المجانية"}
</p>

<div className="flex justify-center">
  <div className="text-center py-4" style={{ maxWidth: "840px" }}>
    <p style={{ fontFamily: "poppins", fontSize: "16px" }}>
      {isLang === "eng"
        ? "Have your invites reflect your personality and character. Among our proffered free pre-designed birthday card template producers, the fact that this card can be customized and adjusted to suit any theme, color, and other preferences helps make card preparation a breeze."
        : "اجعل دعواتك تعكس شخصيتك وطبيعتك. من بين منتجي نماذج بطاقات أعياد الميلاد المجانية المصممة مسبقًا، فإن حقيقة أن هذه البطاقة يمكن تخصيصها وتعديلها لتناسب أي موضوع أو لون أو تفضيلات أخرى تساعد في جعل تحضير البطاقة أمرًا سهلاً."}
    </p>
  </div>
</div>

      <div
        className="card-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {data.map((item) => (

          <NavLink
            to={`/ResumeMaker/temp/${item?.id}`}
            className="hover:no-underline"
          >
            <Card sx={{ maxWidth: 225 }}>
              <CardMedia
                component="img"
                alt="green iguana"
                height="120"
                image={`${apiConfig.API_URL}/aapi/templetes/${item.imagepath}`}
              />
              <CardContent
                className=" m-0 h-8 pb-3 text-left font-medium"
                style={{ fontFamily: "poppins" }}
              >
                <Typography gutterBottom variant="h8" component="div">
                  {item.title}
                </Typography>
              </CardContent>
            </Card>
          </NavLink>
        ))}
      </div>

     <NavLink 
        to={"/resumeMaker/temp/Birthday Cards"}
        >
      <Button
        variant="contained"
        className="btn-grad focus:outline-none"
        style={{
          margin: "auto",
          display: "block",
          borderRadius: "20px",
          width: "180px",
          backgroundColor:
            "#882ED8",
        }}
      >
        SHOW MORE
      </Button>
      </NavLink>


      <p className="my-16 text-[32px] text-center font-[500]">
  {isLang === "eng"
    ? "Find the perfect template for your birthday invitations."
    : "أحصل على النموذج المثالي لدعوات عيد ميلادك."}
</p>

<div className="imageGrid">
  <div>
    <LazyLoadImage src={`${img}`} />
  </div>
  <div>
    <div onClick={() => setImg(`${img1}`)}>
      <LazyLoadImage src={`${img1}`} />
    </div>
    <div onClick={() => setImg(`${img2}`)}>
      <LazyLoadImage src={`${img2}`} />
    </div>
    <div onClick={() => setImg(`${img42}`)}>
      <LazyLoadImage src={`${img42}`} />
    </div>
  </div>
</div>

<div className="catelogTextContainer">
  <div className="catelogText">
    <p style={{ fontSize: "16px" }}>
      {isLang === "eng"
        ? "Helping more people add a personal touch to their invitations can be done with our online birthday card maker. You are clear of this hassle, and you are focused on what matters. Your venue or timing can be updated when needed because we understand this. One-button control on Maker4U is all logical."
        : "يمكن مساعدة المزيد من الأشخاص على إضافة لمسة شخصية إلى دعواتهم باستخدام أداة إنشاء بطاقات أعياد الميلاد عبر الإنترنت. لن تواجه المتاعب، وستركز على ما يهم. يمكن تحديث مكان أو توقيت حفلتك عند الحاجة لأننا نتفهم ذلك. إن التحكم بضغطة زر واحدة على Maker4U أمر منطقي كلياً."}
    </p>

    {/* <Button variant="contained" onClick={handleOpen} style={{marginTop:"10px",width:"180px",borderRadius:"30px", background:  "linear-gradient(to right, #714e91 0%, #5f619f  51%, #433761  100%"}}>Try Now</Button> */}
  </div>
</div>

<h2 className="text-center text-2xl  pb-6 font-bold">
{isLang === 'eng'?(<>
      Ready to create your Birthday invitation card Online with us
    </>):(<>
      جاهز لإنشاء بطاقة دعوة عيد ميلادك عبر الإنترنت معنا
    </>)}
</h2>

<div className="catlogSection">
  <div>
    <LazyLoadImage src={`${img43}`} />
  </div>
  <div>
  </div>
  <div>
    {isLang === 'eng' ? (
      <>
        <p>Design unique birthday invitations to make every moment special</p>
        <p style={{fontSize: '16px'}}>
          A birthday is as special as making a remarkable impression with great invites.
          Let the celebration begin by issuing individualized invitations to excite your invitees!
          All our templates fit any taste, they may be based on the concept of cheerfulness or courtesy.
          Maker4U's birthday card is an excellent choice for you to share the joy of the fest with others.
        </p>
      </>
    ) : (
      <>
        <p>صمم دعوات عيد ميلاد فريدة من نوعها لتجعل كل لحظة مميزة</p>
        <p style={{fontSize: '16px'}}>
          يعتبر عيد الميلاد يوماً مميزًا مثل ترك انطباع رائع مع  دعوات رائعة.
          أبدا الاحتفال بإصدار دعوات فردية لإثارة حماس المدعوين!
          تناسب جميع نماذجنا أي ذوق، وقد تكون مبنية على مفهوم البهجة أو المجاملة.
          تعد بطاقة عيد الميلاد من Maker4U خيارًا ممتازًا لك لمشاركة فرحة العيد مع الآخرين.
        </p>
      </>
    )}
    {/* <Button variant="contained" onClick={handleOpen} style={{marginTop:"10px",width:"180px",borderRadius:"30px", background:  "linear-gradient(to right, #714e91 0%, #5f619f  51%, #433761  100%"}}>Try Now</Button> */}
  </div>
</div>


<div className="catlogSectionTwo">
  <div>
    <LazyLoadImage src={`${img44}`} />
  </div>
  <div></div>
  <div>
    {isLang === 'eng' ? (
      <>
        <p>Elevate Your Celebrations Beyond Ordinary Invitations</p>
        <p style={{fontSize: '16px'}}>
          Make the bold statement of celebrating your life by creating a sparkling birthday slideshow.
          Try to be at least one person to show your appreciation with thoughtful thank-you notes post-celebration.
          Maker4U delivers all the kits required to make your birthdays full of joy and purpose.
        </p>
      </>
    ) : (
      <>
        <p>ميز أحتفالك بأكثر من الدعوات</p>
        <p style={{fontSize: '16px'}}>
          أطلق العنان لإعلانك الجريء عن الاحتفال بحياتك من خلال إنشاء عرض شرائح مميز لعيد الميلاد.
          حاول أن تكون الشخص المميز بإظهار تقديرك من خلال ملاحظات الشكر المكتوبة بعناء بعد الاحتفال.
          توفر Maker4U جميع المجموعات المطلوبة لجعل أعياد ميلادك مليئة بالبهجة والهدف.
        </p>
      </>
    )}
    {/* <Button variant="contained" onClick={handleOpen} style={{marginTop:"10px",width:"180px",borderRadius:"30px", background:  "linear-gradient(to right, #714e91 0%, #5f619f  51%, #433761  100%"}}>Try Now</Button> */}
  </div>
</div>

<div className="catelogAITexContainer">
  <div className="catelogAIText">
    {isLang === 'eng' ? (
      <>
        <p>Easy Birthday Invitations with Maker4U!</p>
        <p style={{fontSize: '16px'}}>
          We allow creating free invitations for a birthday that includes a variety of templates,
          which are professionally designed for all types of themes and styles.
          Peruse our collection to find the right dress for your celebration.
          Then, personalize the template with fonts, icons, etc.
        </p>
      </>
    ) : (
      <>
        <p>دعوات عيد ميلاد سهلة مع Maker4U!</p>
        <p style={{fontSize: '16px'}}>
          نسمح بإنشاء دعوات مجانية لأعياد الميلاد تتضمن مجموعة متنوعة من النماذج المصممة
          بشكل احترافي لجميع السمات والأنماط. تصفح مجموعتنا للعثور على السمة المناسبة لاحتفالك.
          ثم قم بتخصيص النموذج باستخدام الخطوط والأيقونات وما إلى ذلك.
        </p>
      </>
    )}
  </div>
</div>


<div className="cardContainer">
  {isLang === 'eng' ? (
    <>
      <div>
        <div>
          <LazyLoadImage src={`${img7}`} />
        </div>
        <div>
          <p>1. Choose Template</p>
          <p style={{fontFamily: 'poppins', fontWeight: '400', fontSize: '16px'}}>
            View an array of templates that meet your birthday theme and style expectations.
          </p>
        </div>
      </div>

      <div>
        <div>
          <LazyLoadImage src={`${img8}`} />
        </div>
        <div>
          <p>2. Customize Design</p>
          <p style={{fontFamily: 'poppins', fontWeight: '400', fontSize: '16px'}}>
            Personalizing the template involves adding details like the venue, date, time,
            and any additional instructions for your guests.
          </p>
        </div>
      </div>

      <div>
        <div>
          <LazyLoadImage src={`${img9}`} />
        </div>
        <div>
          <p>3. Export</p>
          <p style={{fontFamily: 'poppins', fontWeight: '400', fontSize: '16px'}}>
            Save your personalized invitation and export it to pass on to your guests.
            Enjoy creating unforgettable birthday invitations with Maker4U!
          </p>
        </div>
      </div>
    </>
  ) : (
    <>
      <div>
        <div>
          <LazyLoadImage src={`${img7}`} />
        </div>
        <div>
          <p>1. اختر نموذج</p>
          <p style={{fontFamily: 'poppins', fontWeight: '400', fontSize: '16px'}}>
            اطلع على مجموعة من النماذج التي تلبي توقعاتك بشأن موضوع وأسلوب عيد ميلادك.
          </p>
        </div>
      </div>

      <div>
        <div>
          <LazyLoadImage src={`${img8}`} />
        </div>
        <div>
          <p>2. تخصيص التصميم</p>
          <p style={{fontFamily: 'poppins', fontWeight: '400', fontSize: '16px'}}>
            يتضمن تخصيص النموذج إضافة تفاصيل مثل المكان والتاريخ والوقت وأي تعليمات إضافية لضيوفك.
          </p>
        </div>
      </div>

      <div>
        <div>
          <LazyLoadImage src={`${img9}`} />
        </div>
        <div>
          <p>3. التصدير</p>
          <p style={{fontFamily: 'poppins', fontWeight: '400', fontSize: '16px'}}>
            احفظ دعوتك الشخصية وقم بتصديرها لإهدائها إلى ضيوفك. استمتع بإنشاء دعوات عيد ميلاد لا تُنسى مع Maker4U!
          </p>
        </div>
      </div>
    </>
  )}
      </div>
      <Footer />
    </>
  );
};

export default Catelog;
